import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import {ButtonGroup} from "@material-ui/core";

const styles = {
  toolbarMenu: {
    flexWrap:'wrap',
    margin: '1px 0 0 1px',
    '& > button':{
      margin: '-1px 0 0 -1px',
      borderColor: '#c4c4c4',
      flexBasis:'min-content',
      padding: '5.1px 10.2px',
      fontSize: '0.7225rem',
      height: '34px',
      whiteSpace: 'nowrap',
      '& span:first-child > span:first-child':{
        marginLeft: '-3.4px',
        marginRight: '6.8px'
      },
      '& span:first-child > span:nth-child(2)':{
        marginRight: '-3.4px !important',
        marginLeft: '6.8px !important'
      },
      '& svg':{
        width: '1em',
        height: '1em',
      }
    },
    '& > button:not(:last-child)':{
      borderColor: '#c4c4c4'
    }
  },
  endIcon:{
    '& span:first-child > span:first-child':{
      marginRight: '-3.4px !important',
      marginLeft: '6.8px !important'
    },
  },
};
function ToolbarButtonGroup(props) {
  const {classes, children, ...btnProps} = props;
  return <ButtonGroup
    variant="outlined"
    {...btnProps}
    children={(Array.isArray(children) ? children : [children]).map?.(c => !c?.props?.endIcon ? c : ({...c||{}, props: {...c.props, className: `${classes.endIcon} ${c?.props?.className || ""}`}})) || children}
    className={classes.toolbarMenu}
  />
}

export default withStyles(styles)(ToolbarButtonGroup);
